module.exports = __webpack_public_path__ + "img/msds.85b77cb9.png";